import React from 'react';
import Heading from '@atlaskit/heading';
import { Box, xcss, Flex } from '@atlaskit/primitives';
import { BreadcrumbRenderer, ProjectBreadcrumb } from '@atlassian/jira-breadcrumbs';
import PageHeader from '@atlassian/jira-common-components-page-header';
import { EntryKeys, FeedbackCollectorButton } from '@atlassian/jira-feedback-collector';
import { DocumentTitle } from '@atlassian/jira-global-document-title';
import { useIntl } from '@atlassian/jira-intl';
import { useResource } from '@atlassian/jira-router';
import {
	projectContextResource,
	type ProjectContext,
} from '@atlassian/jira-router-resources-project-context';
import { useCloudId } from '@atlassian/jira-tenant-context-controller';
import { ENTRYPOINT_ID_WORK_SUGGESTION_IN_JIRA_PROJECT, FEEDBACK } from '../../common/constants';
import { InfoBanner } from './info-banner';
import messages from './messages';

export const Header = () => {
	const { data: projectData } = useResource<ProjectContext | null>(projectContextResource);
	const { formatMessage } = useIntl();
	const cloudId = useCloudId();

	return (
		<Box xcss={headerWrapperStyles}>
			<ProjectBreadcrumb
				projectKey={projectData?.projectKey || ''}
				projectName={projectData?.projectName || ''}
			>
				<PageHeader truncateTitle disableTitleStyles breadcrumbs={<BreadcrumbRenderer />}>
					<DocumentTitle title={formatMessage(messages.titleNonFinal)} />
					<Flex xcss={titleContainerStyles} alignItems="center" justifyContent="space-between">
						<Heading size="large" as="h1">
							<Box xcss={pageTitleStyles}>{formatMessage(messages.titleNonFinal)}</Box>
						</Heading>
						<FeedbackCollectorButton
							entrypointId={ENTRYPOINT_ID_WORK_SUGGESTION_IN_JIRA_PROJECT}
							feedbackGroupId={FEEDBACK.PERISCOPE}
							feedbackContext={[
								{
									id: EntryKeys.CLOUD_ID,
									value: cloudId,
								},
							]}
						/>
					</Flex>
				</PageHeader>
			</ProjectBreadcrumb>
			<Box xcss={infoBannerStyles}>
				<InfoBanner />
			</Box>
		</Box>
	);
};

const headerWrapperStyles = xcss({
	paddingLeft: 'space.500',
	paddingRight: 'space.500',
	paddingTop: 'space.0',
	paddingBottom: 'space.0',
	marginBottom: 'space.400',
	width: '100%',
});

const titleContainerStyles = xcss({
	height: 'space.400',
});

const pageTitleStyles = xcss({
	marginTop: 'space.0',
});

const infoBannerStyles = xcss({
	width: '100%',
});
